import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/app/resources/page.js");
